"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const evaluationCategoryEnum = {
  EXPERIMENTAL_DESIGN: 1,
  EXECUTION: 2
};
var _default = evaluationCategoryEnum;
exports.default = _default;